import Swiper, { Navigation } from "swiper";
import Blue from "~/core";

Swiper.use([Navigation]);

new Blue({
  name: "alert",
  selector: ".alerts",
  setup(alerts) {
    const dismissed = sessionStorage.getItem("alert-dismissed") || "false";
    const container = alerts.querySelector(".alerts__content");
    const wrapper = container.querySelector(".alerts__track");
    const slides = container.querySelectorAll(".alert");
    const nav = alerts.querySelector(".alerts__navigation");
    const nextEl = alerts.querySelector(".alerts__nav--next");
    const prevEl = alerts.querySelector(".alerts__nav--prev");
    const count = alerts.querySelector(".alerts__total");
    const count_text = (active, total) => `${active} of ${total}`;
    const close = alerts.querySelector(".alerts__close");

    if (slides.length === 1) {
      alerts.classList.add("alerts--single");
      alerts.dataset.background = slides[0].dataset.background;
    }

    if (dismissed === "false" || !close) {
      alerts.classList.remove("alerts--uninitialized");
      setTimeout(() => {
        const options = {
          init: false,
          loop: true,
          autoplay: false,
          speed: 500,
          spaceBetween: 100,
          slidesPerView: 1,
          
          navigation: {
            nextEl,
            prevEl
          },
          on: {
            init() {},
            slideChangeTransitionStart(swiper) {
              const active = wrapper.querySelector(".swiper-slide-active");
              const bg = active.dataset.background || "";

              count.textContent = count_text(
                swiper.realIndex + 1,
                slides.length
              );

              alerts.dataset.background = bg;
            }
          }
        };

        if (slides.length > 1) {
          container.classList.add("swiper-container");
          wrapper.classList.add("swiper-wrapper");
          slides.forEach(i => {
            i.classList.add("swiper-slide");
          });

          let swiper = new Swiper(container, options);
          swiper.init();
        }

        if (close) {
          this.$retach(close, {
            destination: nav,
            mediaQuery: 991
          });
          this.$addEvents(close, "click enter", () => {
            let start, end;
            start = alerts.offsetHeight;
            alerts.classList.add("alerts--closed");
            end = alerts.offsetHeight;
            alerts.animate([{ height: `${start}px` }, { height: `${end}px` }], {
              duration: 200,
              easing: "ease"
            });
            sessionStorage.setItem("alert-dismissed", "true");
          });
        }
      }, 250);
    }
  }
});
